import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorId}/glade-conversations']['GET'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getGladeConversationsForCreator = async ({ creatorId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/creators/${creatorId}/glade-conversations`);
  return response.data;
};

export default getGladeConversationsForCreator;
